exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".column.bots > .disabled {\n  -webkit-filter: grayscale(1) opacity(0.3);\n          filter: grayscale(1) opacity(0.3);\n}\n.column.bots > .disabled li.column.actions {\n    visibility: hidden;\n}\n", ""]);

// exports
